module.exports = __webpack_public_path__ + "static/media/4.f73b7d8c.jpg";